import {ToasterService} from 'angular2-toaster/angular2-toaster';
import {Response} from "@angular/http";
import {AbstractControl} from "@angular/forms";

export class ResponseService {

    public static toaster: ToasterService = new ToasterService();

    public static parseResponseError(formControls:{ [key: string]: AbstractControl; }, res: Response): { [key: string]: AbstractControl;} {

        let errorData = res.json();

        if (errorData.errors) {

                let errorFields = Object.keys(errorData.errors);
                errorFields.forEach((key) => {
                    if (formControls[key]) {
                        formControls[key].setErrors({'backend': errorData.errors[key]});
                    }
                });
        }
        return formControls;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/response/response.service.ts